export default "__VITE_ASSET__Cpnq1b8G__"